import { useCallback } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { MESSAGES } from "~/resources/Message";
import { FormConfigFile, FormScriptResponse } from "~/models/Commons ";
import {useAddConfigFileMutation } from "~/services/script";

export const useFormConfigFile = (
    editedItem: FormScriptResponse | null,onCloseModal: () => void,refetch: () => void, deploymentScriptId:string
  ) => {
    const [addConfigFile, { isLoading }] = useAddConfigFileMutation();
  
    const { formState: { errors }, handleSubmit, control, setValue, setError, clearErrors, watch }
     = useForm<FormConfigFile>({
      defaultValues: {
        configFiles: null,
      },
    });
  
    const currentConfigFiles = watch('configFiles');
  
    // Handler for config files drop
    const onConfigDrop = useCallback((acceptedFiles: File[]) => {
      const file = acceptedFiles?.[0] || null;
      
      setValue('configFiles', file);
      if (file) {
        clearErrors('configFiles');
      } else {
        setError('configFiles', {
          type: 'manual',
          message: 'Please select a valid file',
        });
      }
    }, [setValue, clearErrors, setError]);
  
    // Form submission handler
    const submitForm = useCallback(async (data: FormConfigFile) => {
      if (!data.configFiles) {
        setError('configFiles', {
          type: 'manual',
          message: MESSAGES.MessageUploadScript,
        });
        return;
      }
  
      try {
        const payload = {
          data,
          deploymentScriptId: deploymentScriptId  || '',
        };
  
        await toast.promise(
          addConfigFile(payload).unwrap(),
          {
            pending: `${editedItem ? 'Updating' : 'Saving'} Script`,
            success: MESSAGES.MessageSucessFullyConfigFile,
            error: MESSAGES.MessageErrorSavingScriptConfigFile,
          }
        );
  
        refetch();
        onCloseModal();
      } catch (error) {
        console.error(MESSAGES.MessageErrorSavingScript, error);
        setError('configFiles', {
          type: 'manual',
          message: MESSAGES.MessageErrorSavingScript,
        });
      }
    }, [addConfigFile, editedItem, onCloseModal, refetch, setError]);
  
    return {
      handleSubmit,
      submitForm,
      control,
      errors,
      currentConfigFiles,
      onConfigDrop,
      isLoading,
    };
  };